import React, { createContext, useContext, useState } from 'react'

export enum ClosureContextOptions {
  singleAccountClosure,
  downgrade,
  cancelSubscription,
}

export const ClosureContext = createContext<{
  closureContext?: ClosureContextOptions
  setClosureContext: (closureContext?: ClosureContextOptions) => void
}>({
  closureContext: undefined,
  setClosureContext: () => null,
})

export const ClosureContextProvider = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const [closureContext, setClosureContext] = useState<
    ClosureContextOptions | undefined
  >(undefined)

  return (
    <ClosureContext.Provider
      value={{
        closureContext,
        setClosureContext,
      }}
    >
      {children}
    </ClosureContext.Provider>
  )
}

export const useClosureContextProvider = () => {
  const { closureContext, setClosureContext } = useContext(ClosureContext)
  return { closureContext, setClosureContext }
}
